import { DialogContent, DialogContentText } from "@mui/material";

import JSONInput from "react-json-editor-ajrm";

import Alert from "@mui/material/Alert";
import React from "react";
import styled from "styled-components";
import { IConfigStorage } from "../../rule-engine-core/Common/IConfigStorage";
import { StyledFormControlLabel } from "../BuildlingBlocks/StyledFormControlLabel";
import { StyledCheckBox } from "../BuildlingBlocks/StyledCheckbox";
import { StyledButton } from "../BuildlingBlocks/StyledButton";
import { locale } from "../../rule-engine-core/Common/JsonInputLocale";
import { log } from "../../rule-engine-core/Log";
import { LogLevel } from "../../rule-engine-core/Plugins/Logging/LogLevel";
import { UIStandardLayer } from "../BuildlingBlocks/UIStandardLayer";

const JSONWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow: hidden;
`;

const TextAreaWrapper = styled.div`
    width: 100%;
    overflow: auto;
    flex: 1;
`;

interface BuilderEditPageProps {
    builder: IConfigStorage;
    updateCallback: () => void;
}

interface Error {
    issue: string;
    onClick: () => void;
}

interface State {
    content: object;
    allowEdit: boolean;
    errors: Error | undefined;
}

export class BuilderEditPage extends React.Component<BuilderEditPageProps, State> {
    constructor(props: BuilderEditPageProps) {
        super(props);
        this.state = {
            content: {},
            allowEdit: false,
            errors: undefined,
        };
    }

    componentDidMount() {
        let data = this.props.builder.getStorageData();
        this.setState({
            content: data,
        });
    }

    componentDidUpdate(prevProps: BuilderEditPageProps) {
        const prevContent = JSON.stringify(prevProps.builder.getStorageData(), null, 2);
        const currentContent = JSON.stringify(this.props.builder.getStorageData(), null, 2);
        if (prevContent !== currentContent) {
            this.setState({
                content: this.props.builder.getStorageData(),
            });
        }
    }

    onClickSave() {
        try {
            const sasobj = this.state.content;
            this.props.builder.setStorageData(sasobj);
        } catch (e) {
            log("Builder Edit Page", LogLevel.ERROR, e.toString());
            this.setState({
                errors: {
                    issue: e.message,
                    onClick: () => {},
                },
            });
        }
    }

    onChangeAllow(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            allowEdit: event.target.checked,
        });
    }

    onCloseParseJSONDialog = () => {
        this.setState({ errors: undefined });
    };

    onCloseLeavingDialog = () => {
        // this.props.onNextMode(true);
    };

    onChange = (newConf: object) => {
        // only update for valid jsObject
        let jsObject = Reflect.get(newConf, "jsObject");
        if (jsObject)
            this.setState({
                content: jsObject,
            });
    };

    render() {
        return (
            <JSONWrapper>
                <JSONHeader>
                    <StyledFormControlLabel
                        label={"Allow Editing"}
                        control={
                            <StyledCheckBox
                                checked={this.state.allowEdit}
                                onChange={this.onChangeAllow.bind(this)}
                            />
                        }
                    />
                    <StyledButton
                        variant="contained"
                        onClick={this.onClickSave.bind(this)}
                        disabled={!this.state.allowEdit}
                    >
                        Save Data
                    </StyledButton>
                </JSONHeader>
                <TextAreaWrapper>
                    <JSONInput
                        placeholder={this.state.content}
                        locale={locale}
                        viewOnly={!this.state.allowEdit}
                        theme={"light_mitsuketa_tribute"}
                        onChange={this.onChange}
                        data-testid="StorageEdit"
                        style={{
                            outerBox: {
                                width: "100%",
                                height: "100%",
                            },
                            container: {
                                width: "100%",
                                height: "100%",
                            },
                        }}
                    />
                </TextAreaWrapper>
                <UIStandardLayer
                    onClose={this.onCloseParseJSONDialog}
                    open={!!this.state.errors}
                    title={"Error"}
                    primaryActionText={"Ok"}
                    onPrimaryAction={this.onCloseParseJSONDialog}
                    renderUI={() => {
                        return (
                            <>
                                <Alert severity="error">Error</Alert>
                                <DialogContent>
                                    <DialogContentText>{this.state.errors?.issue}</DialogContentText>
                                </DialogContent>
                            </>
                        );
                    }}
                ></UIStandardLayer>
                {/* <Dialog
                    onClose={this.onCloseLeavingDialog}
                    aria-labelledby="confirmation-dialog"
                    open={this.props.isLeaving}
                >
                    <Alert severity="warning">Warning</Alert>
                    <DialogContent>
                        <DialogContentText>Your JSON is updated. Do you want to store it?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onClickSave.bind(this)} sx={{color:UIStyleConstants.BLUE_COLOR}}>
                            Yes
                        </Button>
                        <Button onClick={this.onCloseLeavingDialog} color="default">
                            No
                        </Button>
                    </DialogActions>
                </Dialog> */}
            </JSONWrapper>
        );
    }
}

const JSONHeader = styled.div`
    display: flex;
    padding: 6px 12px;

    > *:first-child {
        margin-right: 8px;
    }
`;
